import React from 'react'
import { BsTrophy } from 'react-icons/bs';
import Button from "../../components/EmptyButton";
import { FaBookOpen, FaUsers } from 'react-icons/fa';
import heroImage from '../../assets/images/hero-students.jpg'
const HeroSection = () => {

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-secondary via-background to-secondary/50 mt-48">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl lg:text-6xl font-bold text-foreground leading-tight">
                <span className="text-primary" style={{fontSize: '3rem', fontWeight: '700'}}>Everything you need to</span>
                <span className="block text-foreground" style={{fontSize: '3rem', fontWeight: '700'}}>Succeed in university and beyond</span>
              </h1>
              <p style={{color: '#78726d'}} className="text-xl text-muted-foreground leading-relaxed">
              StudyCrowd.AI help US and UK university students get high grades and build successful careers with simple study materials, personalized tutoring and career mentoring.
              </p>
            </div>

            <div className="flex items-center space-x-3 p-4 bg-card rounded-lg shadow-card border" style={{borderColor: 'lightgray'}}>
              <BsTrophy className="w-6 h-6 text-primary" />
              <p className="text-foreground" style={{fontWeight: '500'}}>
                Find simple study resources created by top students and graduates studying the same degree as you. 
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                filled={true}
                text={'Start Learning Today'}
                className={"text-lg px-8 py-2"}
                onClick={() => window.open('https://studycrowd.ai/login', '_blank')}
              />
              <Button 
                className="text-lg px-8 py-2"
                onClick={() => {
                  const servicesSection = document.querySelector('#services-section');
                  servicesSection?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Learn More
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-8">
              <div className="text-center">
                <div className="text-primary" style={{fontSize: '1.875rem', fontWeight: '700'}}>50K+</div>
                <div className="text-sm text-muted-foreground" style={{color: '#78726d'}}>Active Users</div>
              </div>
              <div className="text-center">
                <div className="text-primary" style={{fontSize: '1.875rem', fontWeight: '700'}}>2000+</div>
                <div className="text-sm text-muted-foreground" style={{color: '#78726d'}}>Tutoring and Career Mentoring Hours Delivered</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-floating">
              <img
                src={heroImage}
                alt="Students studying together"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent"></div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute bg-white -top-4 -right-4 bg-card p-4 rounded-lg shadow-elegant">
              <FaUsers className="w-8 h-8 text-primary" />
            </div>
            <div className="absolute bg-white -bottom-4 -left-4 bg-card p-4 rounded-lg shadow-elegant">
              <FaBookOpen className="w-8 h-8 text-primary" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;